export const PathNamekAppsRoutes = {
  ACCOUNTABILITY: "rendicioncuentas",
  MACROGENERATORS: "macrogenerators",
  PRESETEEISM: "presentismo",
  WEIGHING: "pesajes",
  CONFIG: "config",
};
